import useSearchParams from 'hooks/useSearchParams';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

interface ValidateExperienceSearchParams {
  maxPeople: number;
}

function useValidateExperienceSearchParams({
  maxPeople = 4,
}: ValidateExperienceSearchParams) {
  const searchParams = useSearchParams();
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    const numberOfAdults = parseInt(searchParams.get('adults') || '4', 10);
    const numberOfChildren = parseInt(searchParams.get('children') || '0', 10);
    if (numberOfAdults + numberOfChildren > maxPeople) {
      searchParams.set('adults', String(maxPeople));
      searchParams.set('children', '0');
      history.replace({
        ...location,
        search: searchParams.toString(),
      });
    }
  }, [searchParams, maxPeople, history, location]);

  return null;
}

export default useValidateExperienceSearchParams;
